import { render, staticRenderFns } from "./EditQuestionContent.vue?vue&type=template&id=44fccccc&scoped=true&"
import script from "./EditQuestionContent.vue?vue&type=script&lang=ts&"
export * from "./EditQuestionContent.vue?vue&type=script&lang=ts&"
import style0 from "./EditQuestionContent.vue?vue&type=style&index=0&id=44fccccc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44fccccc",
  null
  
)

export default component.exports